var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.allowed)?_vm._t("default"):(_vm.loading)?_c('v-alert',{attrs:{"type":"info","text":""}},[_vm._v("正在验证财务权限……")]):_c('v-alert',{attrs:{"type":"warning","text":""}},[_vm._v(_vm._s(_vm.error || '没有查看该财务功能的权限')),(_vm.error)?_c('v-btn',{attrs:{"text":"","small":""},on:{"click":_vm.load}},[_vm._v("重试")]):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }